let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9hTcr")).then(() => parcelRequire('9R84O'));